import React, { useState, useEffect } from "react";
import { List, ListItem, ListItemText, Typography, Button, Grid, TextField,CircularProgress,Backdrop,Snackbar } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import Moment from "moment";

import { useTranslation } from "react-i18next";
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { makeStyles } from '@material-ui/styles';
import CreateIcon from '@material-ui/icons/Create';
import CloseIcon from "@material-ui/icons/Close";
import DoneOutlineRoundedIcon from '@material-ui/icons/DoneOutlineRounded';
import { Work } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  root: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));

const Comment = ({ WorkOrderCommentsData,getWorkOrderCommentDetail,workOrderId, readonly }) => {
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedComments, setSortedComments] = useState([]);
  const [maxHeight, setMaxHeight] = useState("400px");

  const [editIndex, setEditIndex] = useState(null);
  const [editedText, setEditedText] = useState("");
  const { t } = useTranslation("work_order");
  const SessionUser = getUser();
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [loading2, setLoading2] = useState(false);
  const classes = useStyles();
  const [responseMessage, setresponseMessage] = useState({
      ErrorCode: '0',
      ErrorDescription: t('success_message')
    });

    const uyariKapat = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setUyari(false);
    };
  

  const calculateMaxHeight = () => {
    const windowHeight = window.innerHeight;
    const headerHeight = 200;
    const newMaxHeight = windowHeight - headerHeight - 50;
    setMaxHeight(newMaxHeight > 200 ? newMaxHeight : 200);
  };

  useEffect(() => {
    calculateMaxHeight();
    window.addEventListener("resize", calculateMaxHeight);

    return () => {
      window.removeEventListener("resize", calculateMaxHeight);
    };
  }, []);

  useEffect(() => {
    setSortedComments([...WorkOrderCommentsData].sort((a, b) => new Date(b.CreateDate) - new Date(a.CreateDate)));
  }, [WorkOrderCommentsData]);

  const sortComments = () => {
    const newOrder = sortOrder === "desc" ? "asc" : "desc";
    const sorted = [...sortedComments].sort((a, b) =>
      newOrder === "desc"
        ? new Date(b.CreateDate) - new Date(a.CreateDate)
        : new Date(a.CreateDate) - new Date(b.CreateDate)
    );
    setSortedComments(sorted);
    setSortOrder(newOrder);
  };

  const handleEditClick = (index, dsc) => {
    setEditIndex(index);
    setEditedText(dsc);
  };

  console.log("WorkOrderCommentsData", WorkOrderCommentsData);

  const handleEdit = (Id) => {
    const data = {
      CommentId: Id ? Id : 0,
      EmployeeId: SessionUser.TechnicianId,
      Date: Moment(new Date()).toISOString(),
      Dsc: editedText,
      WorkOrderId: workOrderId
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading2(true);
    axios
      .post('/UpdateWorkOrderComment', data, config)
      .then(response => {
        setLoading2(false);
        const ResponseData = response.data;
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
          getWorkOrderCommentDetail();
        } else {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          setEditIndex(null);
          getWorkOrderCommentDetail();
        }
      })
      .catch(error => {
        setLoading2(false);
        setresponseMessage({
          ErrorCode: '10',
          ErrorDescription: t('Error') + error.message
        });
        setUyariTip('error');
        setUyari(true);
      });

  }

  return (
    <div style={{ padding: "10px" }}>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
          <Alert
            onClose={uyariKapat}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading2}>
          <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          onClick={sortComments}
          style={{
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            textTransform: "none",
          }}
        >
          {sortOrder === "desc" ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
          <Typography variant="button" style={{ marginLeft: "5px", fontWeight: "bold", color: "white" }}>
            {t("lblDate")}
          </Typography>
        </Button>
      </Grid>

      <div
        style={{
          overflowY: "auto",
          maxHeight: `${maxHeight}px`,
          paddingBottom: "20px",
        }}
      >
        <List>
          {sortedComments.map((comment, index) => (
            <ListItem key={index} divider>
              <ListItemText
                primary={
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {`${comment.Type} - ${comment.Employee}`}
                  </Typography>
                }
                secondary={
                  <>
                    <Typography variant="body2" color="textSecondary">
                      {comment.CreateDate ? (
                        <Typography color="textSecondary">
                          {Moment(comment.CreateDate).format("DD/MM/YYYY HH:mm")}
                        </Typography>
                      ) : null}
                    </Typography>
                    {editIndex === index ? (
                      <TextField
                        fullWidth
                        multiline
                        variant="outlined"
                        value={editedText}
                        onChange={(e) => setEditedText(e.target.value)}
                      />
                    ) : (
                      <Typography
                        variant="body2"
                        style={{
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                          width: "100%",
                        }}
                      >
                        {comment.Dsc}
                      </Typography>
                    )}
                    {comment.UpdatedEmployee && (
                      <Typography variant="body2" style={{ color: "#A31D1D", fontStyle: "italic" }}>
                        Edited by {comment.UpdatedEmployee}  {comment.UpdatedDate ? '-' + Moment(comment.UpdatedDate).format("DD/MM/YYYY HH:mm") : null}
                      </Typography>
                    )}
                  </>
                }
              />
              {!readonly &&
                (editIndex === index ? (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Button color="primary" onClick={() => handleEdit(comment.CommentId)}>
                     <DoneOutlineRoundedIcon style={{color:'#41644A'}}/>
                    </Button>
                    <Button color="secondary" onClick={() => setEditIndex(null)}>
                      <CloseIcon/>
                    </Button>
                  </div>
                ) : (
                  <Button color="secondary" onClick={() => handleEditClick(index, comment.Dsc)}>
                    <CreateIcon style={{color:'#A31D1D'}}/>
                  </Button>
                ))}
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
};

export default Comment;
